import { jsx as _jsx } from "react/jsx-runtime";
import { MediaProvider } from "@vidstack/react";
import Icon from "../../../../icons";
import { cn } from "../../../../utils";
const LOGO_STYLES = {
    MAXIMIZED: "!size-32 top-[4%] left-4",
    PINNED: "!size-24 top-[4%] left-3",
    WITH_PINNED: "!size-5 top-[6%] left-1",
    DEFAULT: "!size-8 top-[6%] left-2",
};
const MiniProvider = ({ index, pinned, maximized, className, showLogo, hasBackground }) => {
    const getLogoStyle = (index) => {
        if (maximized === index)
            return LOGO_STYLES.MAXIMIZED;
        if (pinned === index)
            return LOGO_STYLES.PINNED;
        if (pinned !== undefined)
            return LOGO_STYLES.WITH_PINNED;
        return LOGO_STYLES.DEFAULT;
    };
    return (_jsx("div", { className: cn("flex aspect-video size-full justify-center overflow-hidden rounded-lg", { "bg-gray-12": hasBackground }), children: _jsx(MediaProvider, { className: cn("!aspect-auto !w-fit relative [&>video]:h-full [&>video]:w-auto", hasBackground ? "!rounded-none" : "!rounded-lg", className), children: showLogo && _jsx(Icon, { name: "cb-logo-cobli-name", color: "white", className: cn("absolute z-10 opacity-70", index !== undefined ? getLogoStyle(index) : LOGO_STYLES.MAXIMIZED) }) }) }));
};
export default MiniProvider;
